import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ConverterService, Language, LANGUAGE_NORMALIZER, Occ, OccEndpointsService } from '@spartacus/core';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { loadLanguagesSuccessAction } from '../actions';
import { SITE_CONTEXT_ACTIONS } from '../site-context-actions.type';

@Injectable()
export class DpLoadLanguagesEffect {
  loadLanguages$;

  readonly #actions$ = inject(Actions);
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);
  readonly #converterService = inject(ConverterService);

  constructor() {
    this.loadLanguages$ = createEffect(() =>
      this.#actions$.pipe(
        ofType(SITE_CONTEXT_ACTIONS.LOAD_LANGUAGES),
        switchMap(({ payload }) =>
          this.#loadLanguages(payload).pipe(map((languages) => loadLanguagesSuccessAction({ payload: languages }))),
        ),
      ),
    );
  }

  #loadLanguages(market: string): Observable<Language[]> {
    const url = this.#occEndpoints.getBaseUrl({ baseUrl: true, prefix: true, baseSite: false }) + market + '/languages';
    return this.#httpClient.get<Occ.LanguageList>(url).pipe(
      map((languageList: Occ.LanguageList) => languageList.languages ?? []),
      this.#converterService.pipeableMany(LANGUAGE_NORMALIZER),
    );
  }
}
